/* eslint-disable @typescript-eslint/no-explicit-any */

import { TockNative } from 'middleware/TockNative';
import { get } from 'es-toolkit/compat';
import AppConstants from 'constants/AppConstants';

interface NativePort {
  postMessage(message: any): void;
}

export function createTockNativeListener(store: any) {
  if (window.tockElectron) {
    window.tockElectron.handleReceiveNativeMessage = (message: any) => {
      store.dispatch(message);
    };
  } else {
    window.handleReceiveNativeMessage = (message: any) => {
      store.dispatch(message);
    };
  }
}

// A Redux middleware that interprets actions to be sent to the native side.
// Performs the call and promises when such actions are dispatched.
export function createTockNativeMiddleware() {
  const nativePort =
    get(window, 'webkit.messageHandlers.observe') ||
    (get(window, 'tockElectron') as NativePort | undefined);
  if (nativePort) {
    nativePort.postMessage({ type: AppConstants.GET_NATIVE_VERSIONS });
  }

  return (store: any) => (next: any) => (action: any) => {
    const callAPI = action[TockNative];
    if (typeof callAPI === 'undefined') {
      return next(action);
    }

    try {
      if (nativePort) {
        nativePort.postMessage(callAPI);
        return next({
          type: `${callAPI.type}_STARTING`,
        });
      } else {
        return next({
          type: `${callAPI.type}_FAILED`,
        });
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
    }
  };
}
